import React from "react";

interface IProps {
  pathProps?: React.SVGProps<SVGPathElement>;
}

const LinkIcon = ({ pathProps }: IProps) => {
  return (
    <svg
      width="16"
      height="16"
      viewBox="0 0 16 16"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M8.38047 4.68553L7.964 5.11848C7.9213 5.16243 7.88735 5.215 7.86418 5.27307C7.841 5.33115 7.82906 5.39356 7.82906 5.45661C7.82906 5.51966 7.841 5.58207 7.86418 5.64015C7.88735 5.69823 7.9213 5.7508 7.964 5.79474C8.05093 5.88463 8.16762 5.93495 8.28913 5.93495C8.41064 5.93495 8.52733 5.88463 8.61426 5.79474L9.05162 5.34014C9.48142 4.89306 10.1815 4.806 10.6526 5.2046C10.7786 5.30984 10.882 5.4423 10.9558 5.59317C11.0296 5.74403 11.0722 5.90983 11.0808 6.0795C11.0893 6.24917 11.0636 6.41882 11.0053 6.57714C10.947 6.73545 10.8576 6.8788 10.7428 6.99761L9.45253 8.33978C9.23286 8.56675 8.93809 8.6938 8.63115 8.6938C8.32421 8.6938 8.02944 8.56675 7.80977 8.33978L7.3164 7.82682L6.66659 8.50355L7.15906 9.01604C7.96889 9.85748 9.29341 9.85748 10.1023 9.01604L11.3935 7.67387C11.5983 7.46097 11.758 7.20443 11.8621 6.92125C11.9662 6.63806 12.0122 6.3347 11.9972 6.03125C11.9822 5.7278 11.9065 5.43119 11.7751 5.16106C11.6436 4.89093 11.4595 4.65344 11.2349 4.46434C10.3935 3.75043 9.14807 3.88738 8.38047 4.68553Z"
        fill="white"
        {...pathProps}
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M7.61953 11.3145L8.036 10.8815C8.0787 10.8376 8.11265 10.785 8.13582 10.7269C8.159 10.6688 8.17094 10.6064 8.17094 10.5434C8.17094 10.4803 8.159 10.4179 8.13582 10.3598C8.11265 10.3018 8.0787 10.2492 8.036 10.2053C7.94909 10.1155 7.83249 10.0653 7.71109 10.0653C7.58969 10.0653 7.4731 10.1155 7.38619 10.2053L6.94838 10.6599C6.51858 11.1069 5.81853 11.194 5.3474 10.7954C5.2214 10.6902 5.11804 10.5577 5.04421 10.4068C4.97038 10.256 4.92778 10.0902 4.91924 9.9205C4.9107 9.75083 4.93642 9.58118 4.9947 9.42286C5.05297 9.26455 5.14245 9.1212 5.25717 9.00239L6.54747 7.66022C6.76714 7.43325 7.06191 7.3062 7.36885 7.3062C7.67579 7.3062 7.97056 7.43325 8.19023 7.66022L8.6836 8.17318L9.33341 7.49645L8.84094 6.98396C8.03111 6.14252 6.70659 6.14252 5.89765 6.98396L4.60646 8.32613C4.40169 8.53903 4.24198 8.79557 4.1379 9.07875C4.03383 9.36194 3.98777 9.6653 4.00277 9.96875C4.01777 10.2722 4.0935 10.5688 4.22493 10.8389C4.35636 11.1091 4.54049 11.3466 4.76514 11.5357C5.60652 12.2496 6.85193 12.1126 7.61953 11.3145Z"
        fill="white"
        {...pathProps}
      />
    </svg>
  );
};

export default LinkIcon;
